app.directive('tabmenu', function () {
    return {
        restrict: 'E',
        transclude: true,
        replace: true,
        templateUrl: _pb + 'manageRooms/tabs.html',
        link: function (scope) {

        }
    };
});